<template>
  <div class="theme--light v-card pa-4 blog-listing-main cbg-white-container">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="4" sm="4" class="form-group mb-0">
          <label for class="fz-10px">Release name</label>
          <div class="search-div position-relative">
            <input v-model="releaseName" v-validate="'required'" class="form-control" name="name"
              placeholder="Release name" :disabled="action == 'view'" />
            <span class="text-danger">{{ errors.first("name") }}</span>
          </div>
        </v-col>
        <v-col cols="12" md="4" sm="4" class="form-group mb-0 calendar-point">
          <label for class="fz-10px">Release Date</label>
          <datepicker v-model="releaseDate" ref="datepicker" :masks="{ input: 'DD-MM-YYYY' }"
            name="date" v-validate="'required'">
            <template v-slot="{ inputValue, togglePopover }">
              <input :value="
                inputValue
              " @focus="togglePopover()" class="form-control" placeholder="DD-MM-YYYY" />

            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a" @click="togglePopover()">
            <calendarSVG />
          </div>
          <span class="text-danger">{{ errors.first("date") }}</span>

        </v-col>

        <v-col cols="12" md="4" sm="4" class="form-group mb-0">
          <label for class="fz-10px">Release version</label>
          <div class="search-div position-relative">
            <input v-model="releaseVersion" class="form-control" placeholder="Release version" v-validate="'required'"
              name="releaseVersion" :disabled="action == 'view'" />
          </div>
          <span class="text-danger">{{ errors.first("releaseVersion") }}</span>

        </v-col>
        <v-col cols="12" md="4" sm="4" class="form-group mb-0">
          <label for class="fz-10px">Release title</label>
          <div class="search-div position-relative">
            <input v-model="releaseTitle" class="form-control" placeholder="Release title" v-validate="'required'"
              name="releaseTitle" :disabled="action == 'view'" />
          </div>
          <span class="text-danger">{{ errors.first("releaseTitle") }}</span>

        </v-col>
        <v-col cols="12" md="4" sm="4" class="input-container">
          <label>UI type</label>
          <v-select v-validate="'required'" v-model="viewType" @change="viewTypeChanged(viewType)" :items="typeList"
            placeholder="Select type" required name="type" outlined hide-details :disabled="action == 'view'"></v-select>
          <span class="text-danger">{{ errors.first("type") }}</span>
        </v-col>
        <v-col cols="12" md="4" sm="4" class="input-container">
          <label>Platform</label>
          <v-select v-validate="'required'" v-model="platform" :items="platformTypes" placeholder="Select Platform"
            required name="platform" outlined hide-details :disabled="action == 'view'"></v-select>
          <span class="text-danger">{{ errors.first("platform") }}</span>

        </v-col>

        <v-col cols="12" md="4" sm="4" class="mt-7" v-if="action != 'view'">
          <v-btn class="btn btn-primary mr-4 px-5 py-5" @click="newFeature = true"><span
              class="font-weight-bold font-plus mr-3">+</span> Add New
            Feature</v-btn>
        </v-col>
      </v-row>
      <v-row v-if="features.length" class="mx-0 border-top mt-10">
        <v-col v-if="viewType == 'Listing'" cols="12 p-0 mt-8 mb-6">
          <new-FeatureCard v-for="feature, index in features" :key="index" :feature="feature" :action="action"
            @removeFeature="() => { features.splice(index, 1) }"
            @editFeature="(feature) => { indexToEdit = index; selectedFeature = feature; newFeature = true }" />
        </v-col>
        <v-col v-else cols="12 p-0 mt-8 mb-6">
          <new-FeatureCard :feature="features[0]" :action="action" @removeFeature="() => { features.splice(0, 1) }"
            @editFeature="(feature) => { indexToEdit = 0; selectedFeature = feature, newFeature = true }" />
        </v-col>
      </v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn elevation="2" class="btn btn-danger bg-white text-capitalize mr-4" @click="cancel()">Back</v-btn>
        <v-btn v-if="action == 'create'" class="btn btn-success text-capitalize border-radius"
          @click="createNewRelease">Create</v-btn>
        <v-btn v-if="action == 'edit'" class="btn btn-success text-capitalize border-radius"
          @click="createNewRelease">Save</v-btn>
      </v-col>
    </v-col>
    <v-dialog v-if="newFeature" persistent v-model="newFeature" scrollable width="800">
      <create-NewFeature :feature="selectedFeature" @close="newFeature = false,selectedFeature = {}" @addNewFeature="(data) => {
        if (indexToEdit != null) {
          features[indexToEdit] = data
          newFeature = false
        } else { features.push(data); newFeature = false }
      }" />
    </v-dialog>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
const createNewFeature = () => import("@/components/modals/newFeature.vue");
const newFeatureCard = () => import("@/components/newRelease/newFeatureCard");
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import config from "@/config.js";
export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      indexToEdit: null,
      search: "",
      isEmpty: false,
      newFeature: false,
      platformTypes: ["Web", "Android", "IOS"],
      platform: "",
      typeList: ["Paragraph", "Listing"],
      releaseData: {},
      releaseVersion: '',
      releaseTitle: '',
      releaseName: '',
      viewType: '',
      features: [],
      action: 'create',
      selectedFeature: {},
      releaseDate: new Date(),
    };
  },
  components: {
    Datepicker,
    createNewFeature,
    newFeatureCard,
    ...pickSvg("verticalDotsSVG", 'calendarSVG'),
  },
  mounted() {
    this.id = this.$route.params.id
    if (this.id) {
      this.getRelease()
    }
    this.action = this.$route.params.type ? this.$route.params.type : 'create'
  },

  methods: {
    viewTypeChanged(val) {
      if (this.features.length < 1) {
        return;
      }
      let text = val == 'Paragraph' ? 'Only first feature will be shown to user' : 'All features will be shown to user'
      this.$swal({
        text: text,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: "Ok",
      }).then((valid) => {
        if (!valid.isConfirmed) {
          this.viewType = val == 'Paragraph' ? 'Listing' : 'Paragraph'
        }
      });
    },
    clearSearch() {
      this.search = "";
    },
    getRelease() {
      let url = `${config.BASE_URL}api/v2/admin/version-release?id=${this.id}`;
      this.$http.get(url).then(response => {
        this.releaseData = response.data.data
        this.platform = this.releaseData.platform
        this.releaseName = this.releaseData.release_name
        this.releaseVersion = this.releaseData.release_version
        this.releaseTitle = this.releaseData.release_title
        this.viewType = this.releaseData.view_type
        this.features = this.releaseData.features
        this.releaseDate = this.releaseData.release_date

      });
    },
    cancel() {
      this.$router.go(-1);
    },
    createNewRelease() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.features.length < 1) {
            this.$swal({
              text: "Add Atlease one feature",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "Ok",
            });
            return;
          }
          let params = {
            platform: this.platform,
            release_name: this.releaseName,
            release_version: this.releaseVersion,
            release_title: this.releaseTitle,
            view_type: this.viewType,
            features: this.features,
            release_date: this.releaseDate
          }
          let url = ''
          if (this.action == 'create') {
            url = `${config.BASE_URL}api/v2/admin/create-release`;
          }
          else {
            url = `${config.BASE_URL}api/v2/admin/create-release/${this.id}`;
          }
          this.$http.post(url, params).then(response => {
            if (response.body.status) {
              this.$router.push(`/release`);
            }
          });
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.ww-50 {
  width: 50px;
}

.font-plus {
  font-size: 32px;
}

.action-div {
  .dropdown-menu {
    padding: 0px !important;
  }
}
</style>
